import { AmexLogo } from 'reservations/payments/components/AmexLogo';
import { DiscoverLogo } from 'reservations/payments/components/DiscoverLogo';
import { GenericCardLogo } from 'reservations/payments/components/GenericCardLogo';
import { MasterCardLogo } from 'reservations/payments/components/MasterCardLogo';
import { VisaLogo } from 'reservations/payments/components/VisaLogo';
import {
  CLOVER_AMEX,
  CLOVER_DISCOVER,
  CLOVER_MASTERCARD,
  CLOVER_VISA
} from 'reservations/payments/constants/cards';

export const getCardLogo = (cardType: string) => {
  switch (cardType) {
    case CLOVER_AMEX:
      return AmexLogo;
    case CLOVER_DISCOVER:
      return DiscoverLogo;
    case CLOVER_MASTERCARD:
      return MasterCardLogo;
    case CLOVER_VISA:
      return VisaLogo;
    default:
      return GenericCardLogo;
  }
};
